// src/components/dialog/DlgFolderMap.tsx

import { Dialog, DialogContent, DialogTitle } from '@mui/material'

import { KARMA_BasicDialog } from '@/types/karma/dialog'

import { FolderMap } from '../../pages/Folder/components'

export const DlgFolderMap = ({ onClose, open }: KARMA_BasicDialog) => (
  <Dialog fullWidth={true} maxWidth={'md'} onClose={onClose} open={open}>
    <DialogTitle>Standorte</DialogTitle>

    <DialogContent>
      <FolderMap />
    </DialogContent>
  </Dialog>
)
